import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { obtenerMotivosRechazoAction, ModalRechazoAction, GuardarRechazoAction } from './rechazoAction'
import Button from '../common/button/Button';
import ButtonBase from '../common/button/ButtonBase'
import i18n from '../../config/I18n';
import Input from '../common/input/Input';
// import Checkbox from '../common/checkbox/Checkbox';
import RadioButton from '../common/radiobutton/RadioButton';
import TagManagerUtils from '../../utils/TagManagerUtils';
import '../common/Modal/modal.css';


class ModalRechazo extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = ({
      etapa: 2,
      descripcionMotivo: '',
      idMotivos: [],
      obligatorio: false,
      habilitado: false
    });
  }

  componentDidMount = async () => {
    const { obtenerMotivos, motivosDisponible } = this.props;
    if(motivosDisponible.length===0){
     obtenerMotivos(); 
    }
  }
  

  actualizarMotivo = (e) => {
    e.preventDefault();
    const valor = e.target.value;
    this.setState({ descripcionMotivo: valor })
    const { obligatorio } = this.state;

    if (obligatorio && valor !== '') {
      this.setState({ habilitado: true })
    } else if (obligatorio && valor === '') {
      this.setState({ habilitado: false })
    } else if (!obligatorio) {
      this.setState({ habilitado: true })
    }

  }

  nextWiu = (e) => {
    e.preventDefault();
    this.setState({ etapa: 2 })
  }

  enviar = async (e) => {
    e.preventDefault();
    const { idMotivos } = this.state;
    const { enviar, trackId, motivosDisponible, idEtapa, wv } = this.props;
    const DescripciondeMotivosSelecionados = [];
    const idMotivosNumber = idMotivos.map(i => {
      return Number(i);
    });

    // TAGGEO VENTA A DISTANCIA: ENVIAR MOTIVOS DE RECHAZO
    idMotivos.map(i => {
      motivosDisponible.map(item => {
        if (Number(item.idMotivoRechazo) === Number(i) && item.idEtapa === idEtapa) {
          DescripciondeMotivosSelecionados.push(item.descripcionMotivoRechazo);
          return false;
        }
        return false;
      })
      return false;
    });
    const ms = DescripciondeMotivosSelecionados.join(' - ');
    // TAGGEO 
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc' : '/tef/credito-distancia/encuesta',
      'eve-cat' : 'Click',
      'eve-lab' : ms,
      'ambiente': wv ? 'app':'sitio'
      });
    await enviar(idMotivosNumber[0], idEtapa, trackId);
    const { rechazo } = this.props;
    if (rechazo) {
      window.top.location.href = process.env.URL_PORTAL_PRIVADO;
    }
  }

  ocultarModal = (e) => {
    e.preventDefault();
    const { ocultar, wv } = this.props;
    // TAGGEO 
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc' : '/tef/credito-distancia/encuesta',
      'eve-cat' : 'Click',
      'eve-lab' : 'Volver a inicio',
      'ambiente': wv ? 'app':'sitio'
      });
    this.setState({ idMotivos: [], descripcionMotivo: '', habilitado: false })
    ocultar();
  }

  actualizazarIdMotivos = (e) => {
    const { descripcionMotivo } = this.state;
    const idEntrada = e.target.value;
    const accion = e.target.checked
    if (idEntrada !== "null") {
      // const newidMotivos = idMotivos;
      const newidMotivos = []
      const buscarElemento = newidMotivos.indexOf(idEntrada);
      if (buscarElemento < 1 && accion) {
        newidMotivos.push(idEntrada);
      } else if (buscarElemento >= 0 && !accion) {
        newidMotivos.splice(buscarElemento, 1)
      }
      this.setState({ idMotivos: newidMotivos });
    } else {
      this.setState({ obligatorio: accion });
      if (accion && descripcionMotivo !== '') {
        this.setState({ habilitado: true })
      } else if (accion && descripcionMotivo === '') {
        this.setState({ habilitado: false })
      } else if (!accion) {
        this.setState({ habilitado: true })
      }
    }

    this.setState({ habilitado: true, descripcionMotivo: '' })

  }
  // <Checkbox checkboxValue={item.id} checkboxName={item.descripcion} checkboxFunction={(e) => { this.actualizazarIdMotivos(e) }} /> 

  render() {
    const { etapa, descripcionMotivo, habilitado, obligatorio, idMotivos } = this.state;
    const { motivosDisponible, modalRechazo, idEtapa } = this.props;
    const motivos = motivosDisponible.map((item) => ( idEtapa===item.idEtapa ? (
      <div className="col-12" key={item.idMotivoRechazo}>
        <>
          <RadioButton
            value={item.idMotivoRechazo}
            onChangeCheck={(e) => { this.actualizazarIdMotivos(e) }}
            checkBoxDescripcion={item.descripcionMotivoRechazo}
            name="encuestarachazo"
          />
          {item.tieneComentario && (
            <div className="mbottom20" style={idMotivos.indexOf(item.id.toString()) < 0 ? { display: 'none' } : null}>
              <Input
                type="text"
                name="top"
                htmlForLabel={item.descripcion}
                htmlForInfo={obligatorio ? i18n.t('rechazo.labelB') : null}
                valor={descripcionMotivo}
                funcionOnChange={(e) => { this.actualizarMotivo(e) }}
                largoMaximo={255}
              />
            </div>
          )}
        </>
      </div>
    ):null));

    return (
      <>
        {modalRechazo && (
          <div className="Modal">
            <div className="Modal__container encuesta">
              <ButtonBase etiqueta={i18n.t('rechazo.cerrar')} callClick={this.ocultarModal} />
              <div className="container modal">
                <div className="row">
                  <div className="col-12">
                    <h3 className="titleModal mtop0 mbottom0"><strong>{i18n.t('rechazo.titulo')}</strong></h3>
                    <p className="small">{etapa === 1 ? i18n.t('rechazo.subTitulo') : i18n.t('rechazo.subTitulo')}</p>
                    {etapa === 2 && (
                      <div className="row">
                        <div className="col-12 ptop30">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="row">
                                {motivos}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-12 ptop20">
                    <div className="row">
                      <div className="col-12 col-sm-6 col-md-6" />
                      <div className="col-12 col-sm-6 col-md-6 grid">
                        <Button enabled={etapa === 1 ? true : habilitado} callClick={etapa === 1 ? (e) => { this.nextWiu(e) } : (e) => { this.enviar(e) }} buttonName={etapa === 1 ? i18n.t('rechazo.botonSiSeguro') : i18n.t('rechazo.enviar')} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    motivosDisponible: state.rechazo.motivosDisponible,
    modalRechazo: state.rechazo.showRechazo,
    idSolicitud: state.consultarDetalleDeSolicitud.consultarSolicitud !== null ? state.consultarDetalleDeSolicitud.consultarSolicitud.idSolicitud : null,
    token: state.obtenerCampanaUsuario.token,
    trackId: state.sessionUsuario.trackId,
    rechazo: state.rechazo.responseApi,
    wv: state.webViuw.estado
  }
}


const mapDispatchToProps = dispatch => {
  return {
    obtenerMotivos: () => dispatch(obtenerMotivosRechazoAction()),
    ocultar: () => dispatch(ModalRechazoAction(false)),
    enviar: (idMotivosNumber, idEtapa, trackId) => dispatch(GuardarRechazoAction(idMotivosNumber, idEtapa, trackId))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalRechazo));
